// Core
import React, { Component } from "react";

// Router
import { $state } from "../../router/";

// Logic
import { buildChartRows } from "../../Logic/WidgetAnalytics/chartData";
import {
  buildUrlParams,
  dateGrouping,
} from "../../Logic/WidgetAnalytics/filters";
import { conversionRate } from "../../Logic/WidgetAnalytics/report";

// Components
import { GeckoCardTable } from "@geckolabs/gecko-react-ui";
import StatCard from "../../components/StatCard";
import CustomizedAxisTick from "../../components/StatCard/CustomizedAxisTick";
import { CHART_COLORS } from "../../components/StatCard/theme";
import WidgetAnalyticsFilters from "./components/WidgetAnalyticsFilters";

// Styles
import "./widget-analytics.css";

const formatCount = (value) => Number(value || 0).toLocaleString();

const formatRate = (value) => `${(value || 0).toFixed(1)}%`;

export class WidgetAnalyticsPage extends Component {
  cols() {
    return [
      {
        key: "url",
        name: "URL",
        render: (value) => (
          <a href={value} target="_blank" rel="noopener noreferrer">
            {value}
          </a>
        ),
      },
      {
        key: "widgetLoads",
        name: "Total Widget Loads",
        align: "right",
        render: formatCount,
      },
      {
        key: "conversations",
        name: "Total Widget Conversations",
        align: "right",
        render: formatCount,
      },
      {
        key: "conversionRate",
        name: "Conversion Rate",
        align: "right",
        render: formatRate,
      },
    ];
  }

  rows() {
    return this.props.report.urls.map((row) =>
      Object.assign({}, row, {
        conversionRate: conversionRate(row.widgetLoads, row.conversations),
      })
    );
  }

  pagination() {
    return Object.assign({}, this.props.report.pagination, {
      changePage: (page) =>
        $state.go(
          "widget-analytics",
          buildUrlParams(Object.assign({}, this.props.filters, { page }))
        ),
    });
  }

  chartRows() {
    const { filters, report } = this.props;

    return buildChartRows(
      report.series,
      dateGrouping(filters.from, filters.to)
    );
  }

  chartProps() {
    return {
      series: [
        {
          dataKey: "widgetLoads",
          name: "Widget loads",
          stroke: CHART_COLORS.primary,
          strokeWidth: 2,
        },
        {
          dataKey: "conversations",
          name: "Conversations",
          stroke: CHART_COLORS.secondary,
          strokeWidth: 2,
        },
      ],
      xAxis: {
        dataKey: "label",
        interval: "preserveStartEnd",
        height: 48,
        tick: <CustomizedAxisTick />,
      },
      legendProps: false,
    };
  }

  chartSummary() {
    const { totals } = this.props.report;

    return [
      {
        label: "Widget loads",
        value: formatCount(totals.widgetLoads),
        color: CHART_COLORS.primary,
      },
      {
        label: "Conversations",
        value: formatCount(totals.conversations),
        color: CHART_COLORS.secondary,
      },
      {
        label: "Conversion rate",
        value: formatRate(
          conversionRate(totals.widgetLoads, totals.conversations)
        ),
      },
    ];
  }

  render() {
    return (
      <div className="mainContentWrapper p-2--sm p-5">
        <WidgetAnalyticsFilters
          filters={this.props.filters}
          filterOptions={this.props.filterOptions}
        />

        <div className="widgetAnalytics-overview">
          <StatCard
            name="Loads over time"
            icon="chart-line"
            summary={this.chartSummary()}
            data={this.chartRows()}
            chartProps={this.chartProps()}
            error={this.props.error}
          />
        </div>

        <div className="widgetAnalytics-pages">
          <GeckoCardTable
            name="Pages"
            cols={this.cols()}
            rows={this.rows()}
            pagination={this.pagination()}
          />
        </div>
      </div>
    );
  }
}

export default WidgetAnalyticsPage;
